export const ensureSequenceNumbers = (contentArray) => {
  return contentArray.map((item, index) => {
    if (item.sequence === undefined) {
      return { ...item, sequence: index + 1 };
    }
    return item;
  });
};

export const calculateInsertSequence = (contentArray, insertionIndex) => {
  let insertSequence = contentArray.length + 1;

  if (typeof insertionIndex === "number" && insertionIndex >= 0) {
    const afterItem = contentArray[insertionIndex];
    if (afterItem && afterItem.sequence !== undefined) {
      insertSequence = afterItem.sequence + 1;
    } else {
      insertSequence = insertionIndex + 2;
    }
  } else if (insertionIndex === -1) {
    insertSequence = 1;
  }

  return insertSequence;
};

export const incrementSequencesFrom = (contentArray, thresholdSequence) => {
  return contentArray.map((item) => {
    if (item.sequence >= thresholdSequence) {
      return { ...item, sequence: item.sequence + 1 };
    }
    return item;
  });
};

export const sortBySequence = (contentArray) => {
  return [...contentArray].sort(
    (a, b) => (a.sequence || 0) - (b.sequence || 0)
  );
};

export const insertContentWithSequenceManagement = (
  existingContentArray,
  newContentItem,
  insertionIndex,
  contentType
) => {
  const sequencedContentArray = ensureSequenceNumbers(existingContentArray);

  const insertSequence = calculateInsertSequence(
    sequencedContentArray,
    insertionIndex
  );

  const updatedContentArray = incrementSequencesFrom(
    sequencedContentArray,
    insertSequence
  );

  const newContentWithSequence = {
    ...newContentItem,
    sequence: insertSequence,
    // type: contentType ? contentType : null,
  };

  const insertAt =
    typeof insertionIndex === "number" &&
    insertionIndex >= -1 &&
    insertionIndex <= updatedContentArray.length
      ? insertionIndex + 1
      : updatedContentArray.length;

  updatedContentArray.splice(insertAt, 0, newContentWithSequence);

  return sortBySequence(updatedContentArray);
};
